import { ItRegistryStatusEnum } from 'APIPackage/KnmModule/enums/ItRegistryStatusEnum';

export const itRegistryStatusTitles: Record<ItRegistryStatusEnum, string> = {
  [ItRegistryStatusEnum.ACTIVE]: 'Действует',
  [ItRegistryStatusEnum.CANCELED]: 'Аннулирована',
  [ItRegistryStatusEnum.ABSENT]: 'Отсутствует',
};
